import { Link } from "react-router-dom";

export default function InquiryCtaSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f037185c03bd61fb827aff116efd24f8.jpg"
          alt="Table Privé — Begin your experience"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/70" />
      </div>

      <div className="relative z-10 py-40 md:py-52 px-8 flex flex-col items-center text-center">
        <div className="h-px w-10 bg-[#C9A961] mb-10" />
        <h2 className="font-serif text-[#F0EBE3] text-4xl md:text-6xl lg:text-7xl font-light leading-[1.1] mb-10">
          Your table awaits.
        </h2>
        <p className="text-[#6A6259] text-sm font-light tracking-[0.15em] uppercase max-w-xs mb-14">
          By private inquiry only
        </p>
        <Link
          to="/inquiry"
          className="inline-flex items-center gap-4 border border-[#C9A961]/60 text-[#C9A961] text-[10px] tracking-[0.3em] uppercase font-light px-10 py-5 hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all duration-400 cursor-pointer whitespace-nowrap"
        >
          Request Your Experience
        </Link>
      </div>
    </section>
  );
}
